import React, {useState} from "react";
import FormCatScelte from "./FormCatScelte";
import ModificaNome from "./ModificaNome";
import AggiungiParametri from "./AggiungiParametri";
import stilePulsanti from "../../interfaccia/stilePulsanti";

function FormCatVoce({
    index,
    link,
    menuTemp,
    setMenuTemp,
    variabili,
    salvato,
    setSalvato,
    cancellaLink,
    spostaElemento
}) {

    const [confermato, setConfermato] = useState(true);
    

    function scegliVariabile(e,variabileScelta) {
        e.preventDefault();
        setSalvato(false);

        const nuovoPath = link.path 
            ? link.path+"."+variabileScelta
            : variabileScelta

        const arrayPath = nuovoPath.split('.')

        const variabiliAlNuovoPath = arrayPath.reduce((acc, key) => acc && acc[key], variabili);
        
        const modifiche = {
            nomeVariabile: variabileScelta,
            nomeDisplay: variabiliAlNuovoPath.nome.it,
            url: variabiliAlNuovoPath.urlIntero,
            path: nuovoPath,
            nomeLingue: variabiliAlNuovoPath.nome
        }

        if (variabiliAlNuovoPath.parametri) {
            modifiche.parametri = variabiliAlNuovoPath.parametri
        }
        
        const arrayLinkModificata = menuTemp.links.map(obj=>obj.idLink === link.idLink
            ? { ...obj, ...modifiche }
            : obj  
        )
        
        setMenuTemp({
            ...menuTemp,
            links: arrayLinkModificata
        });
    }

    function cambiaNome(e) {
        e.preventDefault();
        setSalvato(false);

        const value = e.target.value;
        const evtName = e.target.name;
        
        const modifiche = {
            [evtName]: value 
        }
        
        const arrayLinkModificata = menuTemp.links.map(obj=>obj.idLink === link.idLink
            ? { ...obj, nomeLingue:{ ...obj.nomeLingue, ...modifiche} }
            : obj  
        )
        
        setMenuTemp({
            ...menuTemp,
            links: arrayLinkModificata
        });
    }

    function cambiaParametri(e) {
        e.preventDefault();
        setSalvato(false);

        const value = e.target.value;
        const evtName = e.target.name;
        
        const modifiche = {
            [evtName]: value 
        }
        
        const arrayLinkModificata = menuTemp.links.map(obj=>obj.idLink === link.idLink
            ? { ...obj, parametri:{ ...obj.parametri, ...modifiche} }
            : obj  
        )
        
        setMenuTemp({
            ...menuTemp,
            links: arrayLinkModificata
        });
    }
    

    function variabiliGiuste() {
        if (link.path) {
            
            const arrayPath = link.path.split('.')
            const variabiliAlNuovoPath = arrayPath.reduce((acc, key) => acc && acc[key], variabili);

            if (variabiliAlNuovoPath) {
                return variabiliAlNuovoPath
            } else {
                return []
            }    
        } else {
            return variabili
        }
    }

    function reset(e) {
        e.preventDefault();
        setSalvato(false);

        const modifiche = {
            nomeVariabile: "",
            nomeDisplay: "",
            tipo: "",
            url: "",
            path: false,
        }
        

        const arrayLinkModificata = menuTemp.links.map(obj=>obj.idLink === link.idLink
            ? { ...obj, ...modifiche }
            : obj  
        )

        setMenuTemp({
            ...menuTemp,
            links: arrayLinkModificata
        });
    }

    function tornaA(e,index) {
        e.preventDefault();
        
        setSalvato(false);

        const arrayVecchioPath = link.path.split('.')

        const arrayNuovoPath = arrayVecchioPath.slice(0, index + 1);

        const variabiliAlNuovoPath = arrayNuovoPath.reduce((acc, key) => acc && acc[key], variabili);
        
        const modifiche = {
            nomeVariabile: link.path[link.path.length+1],
            nomeDisplay: variabiliAlNuovoPath.nome.it,
            url: variabiliAlNuovoPath.urlIntero,
            path: arrayNuovoPath.join('.')
        }
        
        const arrayLinkModificata = menuTemp.links.map(obj=>obj.idLink === link.idLink
            ? { ...obj, ...modifiche }
            : obj  
        )
        
        setMenuTemp({
            ...menuTemp,
            links: arrayLinkModificata
        });
    }

    function impostaTipo(e,tipo) {
        e.preventDefault();
        setSalvato(false);
        
        const modifiche = {
            tipo: tipo 
        }
        
        const arrayLinkModificata = menuTemp.links.map(obj=>obj.idLink === link.idLink
            ? { ...obj, ...modifiche }
            : obj  
        )
        
        setMenuTemp({
            ...menuTemp,
            links: arrayLinkModificata
        });
    }

    let classPallino = "br-100 h2 w2 flex justify-center items-center b f4 pointer dim"

    if (link.tipo === "titolo") {
        classPallino = classPallino+" sfondoColScuro"
    } else if (link.tipo === "linea" || link.tipo === "spazio") {
        classPallino = classPallino+" sfondoColChiaro black"
    } else {
        classPallino = classPallino+" sfondoColMedio"
    }
    
      
    return <div className="flex flex-wrap pb4 bb mb4">   
        <div className="w-10 tc">
            <div onClick={()=>setConfermato(!confermato)} className={classPallino}>
                {link.tipo==="titolo" && "T"}
                {link.tipo==="linea" && "L"}
                {link.tipo==="spazio" && "S"}
                {link.tipo==="link" && index+1}
                {link.tipo==="scritta" && index+1}
                {link.tipo==="scrittaRossa" && index+1}
            </div>
        </div>
        <div className="w-80 flex flex-column justify-center pointer">
        {confermato && <div className="flex flex-column justify-center pointer">
            <div onClick={()=>setConfermato(!confermato)} className="f4 b">
                {link.tipo==="titolo" && <div className="ttu scrittaColoreAlt">{link.nomeLingue?.it || link.nomeDisplay}</div>}
                {link.tipo==="linea" && <div className="h1 sfondoColChiaro"></div>}
                {link.tipo==="spazio" && <div className="h1 sfondoBiancoTema"></div>}
                {link.tipo==="link" && <div>{link.nomeLingue?.it || link.nomeDisplay || "(modifica)"}</div>}
                {link.tipo==="scritta" && <div className="scrittaColoreMedio">{link.nomeLingue?.it || link.nomeDisplay}</div>}
                {link.tipo==="scrittaRossa" && <div className="red">{link.nomeLingue?.it || link.nomeDisplay}</div>}
            </div>
        </div>}
        {!confermato && <div className="tc nonSelezionabile mb4" onClick={(e)=>{
            setConfermato(true);
            spostaElemento(e,"indietro",index);
            }}><div className={"w2 h2 ba dib dim br-100 bordinoColoreAlt"}>{stilePulsanti.tastoSopraAspetto}</div></div>}
        {(!confermato && !link.tipo) && <div className="flex flex-column justify-center f4 b tc">
            <div className="pointer mb2 dim" onClick={(e)=>{impostaTipo(e,"titolo")}}>Titolo</div>
            <div className="pointer mb2 dim" onClick={(e)=>{impostaTipo(e,"link")}}>Link</div>
            <div className="pointer mb2 dim" onClick={(e)=>{impostaTipo(e,"linea")}}>Linea</div>
            <div className="pointer mb2 dim" onClick={(e)=>{impostaTipo(e,"spazio")}}>Spazio</div>
            <div className="pointer mb2 dim" onClick={(e)=>{impostaTipo(e,"scritta")}}>Scritta</div>
            <div className="pointer mb2 dim" onClick={(e)=>{impostaTipo(e,"scrittaRossa")}}>Scritta rossa</div>
            </div>}
        {(!confermato && link.tipo === "titolo") && <div className="w-80 flex flex-column justify-center ">
            <ModificaNome 
                nomeIT={link.nomeLingue?.it || ""}
                nomeEN={link.nomeLingue?.en || ""}
                nomeFR={link.nomeLingue?.fr || ""}
                handleChange={cambiaNome}
            />
            <div className="red pointer mt2" onClick={reset}>reset</div>
        </div>}
        {(!confermato && link.tipo === "scritta") && <div className="w-80 flex flex-column justify-center ">
            <ModificaNome 
                nomeIT={link.nomeLingue?.it || ""}
                nomeEN={link.nomeLingue?.en || ""}
                nomeFR={link.nomeLingue?.fr || ""}
                handleChange={cambiaNome}
            />
            <div className="red pointer mt2" onClick={reset}>reset</div>
        </div>}
        {(!confermato && link.tipo === "scrittaRossa") && <div className="w-80 flex flex-column justify-center ">
            <ModificaNome 
                nomeIT={link.nomeLingue?.it || ""}
                nomeEN={link.nomeLingue?.en || ""}
                nomeFR={link.nomeLingue?.fr || ""}
                handleChange={cambiaNome}
            />
            <div className="red pointer mt2" onClick={reset}>reset</div>
        </div>}
        {(!confermato && link.tipo === "linea") && <div className="flex flex-column justify-center ">
            <div className="h1 sfondoColChiaro"></div>
            <div className="red pointer mt2" onClick={reset}>reset</div>
        </div>}
        {(!confermato && link.tipo === "link") && <div className="flex flex-column justify-center ">
            <div className="mb3">
                <div className="b pointer mb3" onClick={reset}>
                        root /
                </div>
                {link.path && link.path.split('.').map((pezzoPath,i)=>{
                    return <div key={i} className="b pointer mb3" onClick={(e)=>tornaA(e,i)}>
                        {pezzoPath}/
                        </div>
                })}
            </div>
            <div className="bb bordinoColoreAlt mb4"></div>
            <FormCatScelte 
                variabili={variabiliGiuste()}
                scegliVariabile={scegliVariabile}
                nomeDisplay={link.nomeDisplay}
            />
            <div className="bb bordinoColoreAlt mt4 mb3"></div>
            {link.nomeLingue && <ModificaNome 
                nomeIT={link.nomeLingue.it}
                nomeEN={link.nomeLingue.en}
                nomeFR={link.nomeLingue.fr}
                handleChange={cambiaNome}
            />}
            <div className="bb bordinoColoreAlt mb3 mt3"></div>
            <AggiungiParametri 
                nomeIT={link.parametri?.it || ""}
                nomeEN={link.parametri?.en || ""}
                nomeFR={link.parametri?.fr || ""}
                handleChange={cambiaParametri}
            />
            
            <div className="red pointer mt2" onClick={reset}>reset</div>
        </div>}
        {!confermato && <div className="tc nonSelezionabile mt4" onClick={(e)=>{
            setConfermato(true);
            spostaElemento(e,"avanti",index);
            }}><div className={"w2 h2 ba dib dim br-100 bordinoColoreAlt"}>{stilePulsanti.tastoSottoAspetto}</div></div>}
        </div>
        <div className="w-10 tc">
            <div onClick={(e)=>cancellaLink(e,link.idLink)} className="br-100 h2 w2 flex bg-red justify-center items-center b f4 pointer dim">
                X
            </div>
        </div>
    </div>
    
}

export default FormCatVoce;